/* Vetalus Agile PDP, v0.5.1 port (2026-10-05), DRAFT theme only. File name kept from v0.4.
   - Weight pills click the theme's own (visually hidden) variant picker, so Horizon still does the variant
     change, product form, purchase-options block and sticky bar.
   - The "How you'd like it" cards click the existing purchase-options block's own radios, so its
     selling_plan logic is unchanged; only display text is ours.
   - All prices come from Shopify (variant price and its selling plan allocation, in #vp4-variant-data).
   - We never show a ship interval. No product, variant or selling plan data is changed.
   - Testimonial carousel: scroll-snap, dots, desktop arrows, no autoplay. */
(() => {
  if (window.__vtPdpV051) return; window.__vtPdpV051 = true;
  const money = (c) => '$' + (c / 100).toFixed(2);
  const day = (c) => money(Math.round(c / 60));
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
  const setAttr = (el, a, v) => { if (el && el.getAttribute(a) !== v) el.setAttribute(a, v); };
  const plural = (n, w) => n + ' ' + w + (n === 1 ? '' : 's');
  let DATA = null;
  const data = () => {
    if (DATA) return DATA;
    try { DATA = JSON.parse($('#vp4-variant-data').textContent); } catch (e) { DATA = null; }
    return DATA;
  };
  const subRadio = () => $('subscription-options [data-role="subscribe"]');
  const oneRadio = () => $('subscription-options [data-role="onetime"]');
  const subscribing = () => { const r = subRadio(); return !!(r && r.checked); };
  function current() {
    const d = data(); if (!d) return null;
    const form = $('form[id^="BuyButtons-ProductForm"]');
    const idEl = form && form.querySelector('input[name="id"]');
    let v = idEl && d.variants.find((x) => String(x.id) === String(idEl.value));
    if (!v) { const c = $('variant-picker input[type="radio"]:checked'); v = c && d.variants.find((x) => x.opt === c.value); }
    return v || d.variants[0];
  }
  let busy = false;
  function render() {
    if (busy) return; busy = true;
    try {
      const d = data(); const v = current(); if (!d || !v) return;
      const hasSub = v.sub != null;
      const sub = subscribing() && hasSub;
      const price = sub ? v.sub : v.price;
      const pct = hasSub ? Math.round(((v.price - v.sub) / v.price) * 100) : 0;
      // price row
      setText($('[data-vt="price"]'), money(price));
      setText($('[data-vt="was"]'), sub ? money(v.price) : '');
      const pill = $('[data-vt="save"]'); if (pill) { pill.hidden = !(sub && pct > 0); setText(pill, 'SAVE ' + pct + '%'); }
      setText($('[data-vt="perday"]'), '60-day plan · ' + day(price) + '/day');
      // weight pills
      $$('.vt5-size').forEach((t) => {
        const on = t.dataset.vtId === String(v.id);
        setAttr(t, 'aria-checked', String(on)); t.tabIndex = on ? 0 : -1;
      });
      // purchase cards (display only)
      const so = $('.vt5-opt[data-plan="sub"]'), oo = $('.vt5-opt[data-plan="one"]');
      if (so) { setAttr(so, 'aria-checked', String(sub)); so.hidden = !hasSub; }
      if (oo) setAttr(oo, 'aria-checked', String(!sub));
      $$('[data-vt="savepct"]').forEach((el) => setText(el, 'SAVE ' + pct + '%'));
      if (hasSub) {
        setText($('[data-vt="subprice"]'), money(v.sub));
        setText($('[data-vt="subwas"]'), money(v.price));
        setText($('[data-vt="subjars"]'), plural(v.jars, 'jar') + ' · ' + plural(v.jars, 'chew') + ' a day');
        setText($('[data-vt="subday"]'), '60-day plan · ' + day(v.sub) + '/day');
      }
      setText($('[data-vt="oneprice"]'), money(v.price));
      setText($('[data-vt="oneline"]'), plural(v.jars, 'jar') + ' · ships once · ' + day(v.price) + '/day');
      // ATC label (C-09)
      const atc = $('form[id^="BuyButtons-ProductForm"] .add-to-cart-text__content > span > span');
      const btn = atc && atc.closest('button');
      if (atc && btn && !btn.disabled) setText(atc, 'Start my 60-day plan · ' + money(price));
      // sticky bar: display text only, no ship interval
      const sv = $('.sticky-add-to-cart__variant');
      if (sv) setText(sv, (sub ? 'Subscribe · ' : 'One-time · ') + money(price) + ' · 60-day plan');
      const sp = $('.sticky-add-to-cart__price .price'); if (sp) setText(sp, money(price));
      const sb = $('.sticky-add-to-cart__button .add-to-cart-text__content > span:first-child');
      const sbtn = $('.sticky-add-to-cart__button');
      if (sb && sbtn && !sbtn.disabled) setText(sb, 'Start plan');
    } finally { busy = false; }
  }
  let t = 0; const soon = () => { clearTimeout(t); t = setTimeout(render, 30); };

  // pills: 4 in a row; fall back to 2x2 only if a label would not fit
  function fitPills() {
    const g = $('.vt5-sizes'); if (!g) return;
    g.classList.remove('vt5-wrap2');
    requestAnimationFrame(() => { if ($$('.vt5-size', g).some((b) => b.scrollWidth > b.clientWidth + 1)) g.classList.add('vt5-wrap2'); });
  }

  document.addEventListener('click', (e) => {
    const pillEl = e.target.closest('.vt5-size');
    if (pillEl) {
      const inp = $$('variant-picker input[type="radio"]').find((i) => i.value === pillEl.dataset.vtOpt);
      if (inp && !inp.checked) inp.click();
      $$('.vt5-size').forEach((b) => setAttr(b, 'aria-checked', String(b === pillEl)));
      soon(); return;
    }
    const opt = e.target.closest('.vt5-opt');
    if (opt) {
      const r = opt.dataset.plan === 'sub' ? subRadio() : oneRadio();
      if (r && !r.checked) r.click();
      soon();
    }
  });
  document.addEventListener('keydown', (e) => {
    const el = e.target.closest && e.target.closest('.vt5-size, .vt5-opt'); if (!el) return;
    const sel = el.classList.contains('vt5-size') ? '.vt5-size' : '.vt5-opt:not([hidden])';
    const all = $$(sel); const i = all.indexOf(el);
    const k = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (k) { e.preventDefault(); const nx = all[(i + k + all.length) % all.length]; nx.focus(); nx.click(); }
    else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); el.click(); }
  });
  document.addEventListener('variant:update', () => { soon(); setTimeout(render, 350); }, true);
  document.addEventListener('vt:pricing-change', soon, true);
  document.addEventListener('change', soon, true);

  function carousel() {
    $$('.vt5-tcaro').forEach((root) => {
      if (root.__vt) return; root.__vt = true;
      const track = $('.vt5-tcaro-track', root);
      const slides = $$('.vt5-tcaro-slide', root);
      const dots = $$('.vt5-tcaro-dot', root);
      let index = 0;
      const mark = () => dots.forEach((d, n) => d.setAttribute('aria-current', n === index ? 'true' : 'false'));
      const go = (i) => { index = (i + slides.length) % slides.length; track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(); };
      const sync = () => {
        const w = track.clientWidth || 1; index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))); mark();
      };
      const prev = $('.vt5-prev', root), next = $('.vt5-next', root);
      prev && prev.addEventListener('click', () => go(index - 1));
      next && next.addEventListener('click', () => go(index + 1));
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      track.addEventListener('scroll', () => { clearTimeout(track.__t); track.__t = setTimeout(sync, 80); }, { passive: true });
    });
  }

  const start = () => {
    render(); fitPills(); carousel();
    window.addEventListener('resize', fitPills);
    const root = $('.product-details') || document.body;
    new MutationObserver(soon).observe(root, { childList: true, subtree: true });
    const st = $('sticky-add-to-cart'); if (st) new MutationObserver(soon).observe(st, { childList: true, subtree: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPills);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
